
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class DelhiveryApiDetailsDialog extends Serenity.EntityDialog<DelhiveryApiDetailsRow, any> {
        protected getFormKey() { return DelhiveryApiDetailsForm.formKey; }
        protected getIdProperty() { return DelhiveryApiDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return DelhiveryApiDetailsRow.localTextPrefix; }
        protected getNameProperty() { return DelhiveryApiDetailsRow.nameProperty; }
        protected getService() { return DelhiveryApiDetailsService.baseUrl; }
        protected getDeletePermission() { return DelhiveryApiDetailsRow.deletePermission; }
        protected getInsertPermission() { return DelhiveryApiDetailsRow.insertPermission; }
        protected getUpdatePermission() { return DelhiveryApiDetailsRow.updatePermission; }

        protected form = new DelhiveryApiDetailsForm(this.idPrefix);

    }
}